import React from "react";
import { Link } from "react-router-dom";
import { Button } from "primereact/button";
import localeText from "../../../../../../locale";
import { formatPrice } from "../../../../../../utilities/formatPrice";
import {
  EXTRAPAY_CYCLE_PATH,
  EXTRAPAY_KNOW_PATH,
  EXTRAPAY_RATE_ANCHOR,
  EXTRAPAY_WITHDRAW_PATH,
} from "../constants";
import {
  getCycleProgressPercent,
  getOrdersProgressLabel,
  getRemainingPurchasesLabel,
} from "../cycleCopy";
import { formatExtrapayRate } from "../formatExtrapay";
import ExtrapayInfoNote from "./ExtrapayInfoNote";

export const PointsSummaryCard = ({ pointsBalance, ordersInCycle, cycle }) => (
  <div
    className="border-round-lg flex flex-column gap-4 p-4 h-full"
    style={{ border: "1px solid var(--theme-border, #EBEBEB)" }}
  >
    <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
      {localeText("extrapayFlowPointsTitle")}
    </div>
    <div className="text-5xl" style={{ color: "var(--theme-primary, #1DAF61)" }}>
      {formatPrice(pointsBalance)}{" "}
      <span className="text-sm">{localeText("extrapayFlowPointsUnit")}</span>
    </div>
    <div>
      <div className="flex justify-content-between text-sm font-medium mb-2">
        <span>{getOrdersProgressLabel(ordersInCycle)}</span>
        <Link
          className="underline"
          to={EXTRAPAY_CYCLE_PATH}
          style={{ color: "var(--theme-secondary, #335CFF)" }}
        >
          {localeText("extrapayFlowCycleLabel", { cycle })}
        </Link>
      </div>
      <div
        className="border-round-xl overflow-hidden"
        style={{ height: "8px", backgroundColor: "#E4E7EC" }}
      >
        <div
          style={{
            width: `${getCycleProgressPercent(ordersInCycle)}%`,
            height: "100%",
            backgroundColor: "var(--theme-primary, #1DAF61)",
          }}
        />
      </div>
      <p className="text-xs mt-2" style={{ color: "var(--theme-text-muted)" }}>
        {getRemainingPurchasesLabel(ordersInCycle)}
      </p>
    </div>
    <Link
      to={EXTRAPAY_KNOW_PATH}
      className="text-sm font-medium underline"
      style={{ color: "var(--theme-secondary, #335CFF)" }}
    >
      <i className="pi pi-info-circle mr-2 text-sm" />
      {localeText("howItWorks")}
    </Link>
  </div>
);

export const ExcBalanceCard = ({ excBalance }) => {
  const disabled = excBalance <= 0;
  return (
    <div
      className="border-round-lg p-4 flex flex-column gap-4 h-full"
      style={{
        backgroundColor: "color-mix(in srgb, var(--theme-primary, #1DAF61) 8%, #ffffff)",
        border: "1px solid color-mix(in srgb, var(--theme-primary, #1DAF61) 24%, #ffffff)",
      }}
    >
      <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
        {localeText("extrapayFlowPlatformBalance")}
      </div>
      <div className="text-5xl" style={{ color: "var(--theme-primary, #1DAF61)" }}>
        {formatPrice(excBalance)} <span className="text-sm">EXC</span>
      </div>
      <div>
        <p className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
          {localeText("extrapayFlowCanRequest", { amount: formatPrice(excBalance) })}
        </p>
        <Link to={EXTRAPAY_WITHDRAW_PATH} className={disabled ? "pointer-events-none" : ""}>
          <Button
            label={localeText("extrapayFlowRequestWithdraw")}
            className="border-round-md border-none text-sm font-semibold"
            style={{
              backgroundColor: disabled ? "#E4E7EC" : "var(--theme-primary, #1DAF61)",
              color: disabled ? "#98A2B3" : "#fff",
              padding: "0.625rem",
            }}
            disabled={disabled}
          />
        </Link>
      </div>
    </div>
  );
};

export const ConversionRateNotice = ({ conversionRate }) => (
  <div className="mt-3">
    <ExtrapayInfoNote
      text={
        <>
          {localeText("extrapayFlowRateNotice", { rate: formatExtrapayRate(conversionRate) })}{" "}
          <Link to={`${EXTRAPAY_KNOW_PATH}#${EXTRAPAY_RATE_ANCHOR}`} style={{ color: "#335CFF" }}>
            {localeText("extrapayFlowUnderstandRate")}
          </Link>
        </>
      }
    />
  </div>
);
